import { type ComponentPropsWithRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "hooks/use-selector";
import {
  selectCoverages,
  selectTravelers,
  selectTripDays,
  selectTripEndDate,
  selectTripStartDate,
} from "store/quote/selectors";
import { LocalTimezoneDate } from "utils/date";
import { dateRangeFormatter } from "utils/formatters/date-range";
import {
  DatesAndTravelers,
  TripInfo,
  Days,
  TravelersButton,
  TravelersButtonIcon,
  MWebTripDetails,
  MWebDatesAndTravelers,
  AddonsList,
  AddOnListItem,
  CheckIcon,
} from "./styles";
import { BackButton } from "layouts/offer-bc/contentBC/back-button";

import { useBreakpoint } from "hooks/use-breakpoint";
import { TravelersDropList } from "../travelers-list";
import { AddonsButton } from "../../add-ons/mweb-addons-button";
import { useEventListener } from "hooks/use-event-listener";
import { useAddOnsStrings } from "screens/offer/utils";
import { useNavigate } from "react-router-dom";
import { DestinationSection } from "../destination";
export function TripInfoSection(props: ComponentPropsWithRef<"div">) {
  const mdBreakpoint = useBreakpoint("md");
  const tripStartDate = useSelector(selectTripStartDate);
  const tripEndDate = useSelector(selectTripEndDate);
  const coverages = useSelector(selectCoverages);
  const { extraAddOns } = useAddOnsStrings();

  const addedCoverages = coverages?.filter(
    (coverage) =>
      (!coverage.isBase && !coverage.isDefault && coverage.isSelected) ||
      extraAddOns.some((addOn) => addOn.coverageType === coverage.coverageType),
  );

  const days = useSelector(selectTripDays);

  const { t } = useTranslation("screens", { keyPrefix: "offer.tripDetails" });

  const travelers = useSelector(selectTravelers);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const navigate = useNavigate();

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEventListener(
    "scroll",
    window,
    () => {
      if (anchorEl !== null) {
        setAnchorEl(null);
      }
    },
    [anchorEl],
  );

  useEventListener(
    "scroll",
    window,
    () => {
      if (anchorEl !== null) {
        setAnchorEl(null);
      }
    },
    [anchorEl],
  );

  return mdBreakpoint ? (
    <TripInfo {...props}>
      <Days>{t("day", { count: days || 1 })}</Days>
      <DestinationSection />
      {!!tripStartDate && !!tripEndDate && (
        <DatesAndTravelers>
          {dateRangeFormatter(
            new LocalTimezoneDate(tripStartDate),
            new LocalTimezoneDate(tripEndDate),
          )}
          <TravelersButton
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
          >
            | {t("travelerCount", { count: travelers.length })}
            <TravelersButtonIcon />
          </TravelersButton>
          <TravelersDropList anchorEl={anchorEl} handleClose={handleClose} />
        </DatesAndTravelers>
      )}
    </TripInfo>
  ) : (
    <MWebTripDetails>
      <BackButton
        onClick={() => {
          navigate(-1);
        }}
      ></BackButton>
      <Days>{t("day", { count: days || 1 })}</Days>
      <DestinationSection />
      {!!tripStartDate && !!tripEndDate && (
        <>
          <MWebDatesAndTravelers>
            {dateRangeFormatter(
              new LocalTimezoneDate(tripStartDate),
              new LocalTimezoneDate(tripEndDate),
            )}
            <TravelersButton
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
              }}
            >
              {t("travelerCount", { count: travelers.length })}
              <TravelersButtonIcon />
            </TravelersButton>
            <TravelersDropList anchorEl={anchorEl} handleClose={handleClose} />
          </MWebDatesAndTravelers>
          {Boolean(addedCoverages?.length) && (
            <AddonsList>
              {addedCoverages?.map((coverage) => (
                <AddOnListItem key={coverage.coverageType}>
                  <CheckIcon />
                  {coverage.title}
                </AddOnListItem>
              ))}
            </AddonsList>
          )}
          <AddonsButton />
        </>
      )}
    </MWebTripDetails>
  );
}
